import { makeQueryStringDync, errorServeiceHandler } from '../../helper'
const actions = {
    getChannelListsDetail: (context, filterData) => {
    let url = '/subscriber/v1/plan/channel'
    return new Promise( (resolve, reject) => {
      let queryStr = ''
      queryStr = makeQueryStringDync(filterData)
      fetch(context.getters.baseUrl + url + queryStr, {
        method: 'GET'
      })
      .then(errorServeiceHandler)
      .then((response) => {
        return response.json()
      }).then((data) => {
        console.log("phase 2")
        if (context.getters.getMode == "development") {
          resolve()
        }
        else {
          resolve(data)
        }
      }).catch((error) => {
        if (context.getters.getMode == "development") {
          resolve()
          return
        }
        reject(error)
      });
    });
  }
};

export default {
    actions
};


// WEBPACK FOOTER //
// ./src/store/modules/addpacks/channelList.js